<div *ngIf="isLoading">Loading Domain List...</div>

<select *ngIf="!isLoading" (change)="optionChanged.emit(true)" [compareWith]="byId" class="form-control" name="domain"
        [(ngModel)]="model.domain" [required]="required">
  <option *ngFor="let singleDomain of domains" [ngValue]="singleDomain">{{ singleDomain.name }}</option>
</select>
